import InputFilter from "./InputFilter"

const UntabbedFilters = ({ filters, formValues, handleInput, onEnter, disabled, errors }) => {
    return (
        <div className="row form-basic">
            {filters.map(filter => (
                <InputFilter {...{filter, formValues, handleInput, onEnter, disabled, errors }} key={filter.field} />
            ))}
        </div>
    )
}

export default UntabbedFilters
